import { gql } from '@apollo/client';

export const SAVE_MARKETPLACE_LOCATION_TEMPLATE = gql`
  mutation ($locationId: String!, $template: String!, $footer: String, $header: String) {
    saveMarketplaceLocationTemplate(locationId: $locationId, template: $template, footer: $footer, header: $header)
  }
`;
